//hook
import { useState, useEffect } from "react"
import { useApi } from "../../hooks/useApi"
import { UserConsumer } from "../../hooks/context/UserContext"

//api
import { GetMyCarsApi } from "../../api/Host/GetMyCarsApi"
import { DeleteCarApi } from '../../api/Host/DeleteCarApi';

//component
import NoData from "../../component/NoData"
import AddCar from "../../popup/AddCar"
import MyCarCard from "../../component/carCard/MyCarCard"
import OfferList from "../../popup/offers/OfferList"
import DeleteConfirmation from "../../popup/DeleteConfirmation";

//image
import carPlaceHolder from "../../assets/carPlaceHolder.png"

//mui
import { DialogProps } from '@mui/material/Dialog';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

//mui icon
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import ReplayIcon from '@mui/icons-material/Replay';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';

//tranlsate
import { useTranslation } from "react-i18next";
import i18n from "../../translate/i18n"

//type
import { MyCarType } from "../../api/Host/type/AddCarType"

const MyCar = () => {
  const {t} = useTranslation()
  const { 
    loading: myCarsLoading, 
    error: myCarsError, 
    HandlerApi: getMyCars
    } = useApi(GetMyCarsApi, "GET")
    let [myCars, setMyCars] = useState<MyCarType[]>([])
    let [selectedCar, setSelectedCar] = useState<MyCarType>()
    let [openDeleteConfirmation, setOpenDeleteConfirmation] = useState<boolean>(false);
    let [showCarOffers, setShowCarOffers] = useState<{open:boolean,scrollType: DialogProps['scroll']}>({
    open:false,
    scrollType: "paper",
  })
  const [openAddCar, setOpenAddCar] = useState<{open:boolean,scrollType: DialogProps['scroll']}>({
    open:false,
    scrollType: "paper",
  });
  const {
      loading: deleteCarLoading,
      error: deleteCarError,
      HandlerApi: deleteCar
  } = useApi(DeleteCarApi, "DELETE");

  useEffect(() => {
  const fetchData = async () => {
    let result = await getMyCars();
    setMyCars(result.data);
  }
  fetchData();
  },[])

  return (
    <div className="relative">
      <div onClick={()=> setOpenAddCar({open: true, scrollType: "paper"})} className={`w-fit mb-3 cursor-pointer flex justify-between items-center gap-2 p-2 text-[12px] rounded-lg text-white bg-paretnerColor`}>
        <p> 
          <ControlPointIcon/>
        </p>
        <p>{t("add_car")}</p>
      </div>
      <Card className="!bg-paretnerColor !text-white mb-5">
        <CardContent className="!flex items-center gap-5">
          <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
            <DirectionsCarFilledIcon className="!text-white !text-[50px]"/>
          </Typography>
          <div>
            <Typography variant="h5" component="div">
              {t("cars_count")}
            </Typography>
            <Typography variant="body2">
              {myCarsLoading ? 0 : myCars?.length} - {t("car")}
            </Typography>
          </div>
        </CardContent>
      </Card>
      <div>
        {
          <div>
            {
              myCarsLoading
              ?
                <div className='flex justify-center'>
                  <CircularProgress/>
                </div>
              : myCarsError
                ?
                  <div className='cursor-pointer flex justify-center'>
                    <ReplayIcon onClick={()=>{getMyCars()}} className='!text-[40px]'/>
                  </div>
                :
                  myCars.length === 0
                  ? <NoData title={t("drivers")} description={t("you_don't_have_any_drivers_yet")} image={carPlaceHolder}/>
                  :
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(270px, 1fr))", gap: "20px" }}>
                    {
                      myCars.map((element, index) => (
                        <MyCarCard
                        key={index} 
                        setOpenAddCar={setOpenAddCar}
                        setSelectedCar={setSelectedCar}
                        element={element}
                        setShowCarOffers={setShowCarOffers}
                        setOpenDeleteConfirmation={setOpenDeleteConfirmation}
                        />
                      ))
                    }
                  </div>
            }
          </div>
        }
      </div>
      {
        openAddCar.open
        ? <AddCar 
          selectedCar={selectedCar}
          setSelectedCar={setSelectedCar}
          openAddCar={openAddCar} 
          setOpenAddCar={setOpenAddCar}
          setMyCars={setMyCars} 
          getMyCars={getMyCars}
        />
        : null
      }
      {
        showCarOffers.open
        ? 
        <OfferList 
          showCarOffers={showCarOffers}
          setShowCarOffers={setShowCarOffers}
          setSelectedCar={setSelectedCar}
          selectedCar={selectedCar}
        />
        : null
      }
      <DeleteConfirmation
      openDeleteConfirmation={openDeleteConfirmation} 
      setOpenDeleteConfirmation={setOpenDeleteConfirmation}
      id={selectedCar?.id}
      deleteFunction={deleteCar}
      deleteLoading={deleteCarLoading}
      recallFunction={getMyCars}
      setData={setMyCars}
      />
    </div>
  )
}

export default MyCar